import { useState, useCallback } from 'react';
import { logError, logInfo } from '../../../../../utils/logger';

export const useMapInitialization = () => {
  const [map, setMap] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapError, setMapError] = useState(null);

  const handleMapLoad = useCallback((mapInstance) => {
    if (!mapInstance) return;
    setMap(mapInstance);
    setMapLoaded(true);
    logInfo('Map loaded successfully');
  }, []);

  const handleMapError = useCallback((error) => {
    logError('Map error:', error);
    setMapError(error.message);
  }, []);

  return {
    map,
    mapLoaded,
    mapError,
    handleMapLoad,
    handleMapError
  };
};